import React from "react"
import "./heart-score.scss"

const HeartScore = ({ score }) => {
  return (
    <div className={"f-likes-container"}>
      <span
        className={`f-icon f-icon-heart ${
          score >= 1 ? "icon2-corazon-relleno1" : "icon-2-corazon-outline"
        }`}
      />
      <span
        className={`f-icon f-icon-heart ${
          score >= 2 ? "icon2-corazon-relleno1" : "icon-2-corazon-outline"
        }`}
      />
      <span
        className={`f-icon f-icon-heart ${
          score >= 3 ? "icon2-corazon-relleno1" : "icon-2-corazon-outline"
        }`}
      />
      <span
        className={`f-icon f-icon-heart ${
          score >= 4 ? "icon2-corazon-relleno1" : "icon-2-corazon-outline"
        }`}
      />
      <span
        className={`f-icon f-icon-heart ${
          score >= 5 ? "icon2-corazon-relleno1" : "icon-2-corazon-outline"
        }`}
      />
    </div>
  )
}

export default HeartScore
